import { Input, AutoComplete, Spin } from 'antd'
import React, { useState } from 'react'
import { SearchOutlined } from '@ant-design/icons'

interface PostcodeLookupProps {
    onAddressSelected: (address: any) => void
    onclose: () => void
}

const PostcodeLookup: React.FC<PostcodeLookupProps> = ({
    onAddressSelected,
    onclose,
}) => {
    const [postcode, setPostcode] = useState('')
    const [addresses, setAddresses] = useState<any[]>([])
    const [loading, setLoading] = useState(false)

    const handlePostcodeLookup = async (value: string): Promise<void> => {
        setPostcode(value)
        if ((value?.trim()).length === 0) {
            setAddresses([])
            return
        }

        setLoading(true)
        try {
            const response = await fetch(
                `https://api.ideal-postcodes.co.uk/v1/addresses?query=${encodeURIComponent(value)}&api_key=ak_kqrv9kb6ScQqn2jMi0dK6PX6uMktS`
            )
            const data = await response.json()
            if (data?.result !== null && Array.isArray(data.result.hits)) {
                setAddresses(data.result.hits)
            } else {
                setAddresses([])
            }
        } catch (err) {
            console.error('Error fetching addresses:', err)
            setAddresses([])
        }
        setLoading(false)
    }

    const handleAddressSelect = (value: string): void => {
        const selected = addresses.find((addr) => addr.id === value)
        if (selected !== null) {
            setPostcode(selected.postcode)
            onAddressSelected({
                line_1: selected.line_1 ?? '',
                line_2: selected.line_2 ?? '',
                line_3: selected.line_3 ?? '',
                post_town: selected.post_town ?? '',
                postcode: selected.postcode ?? '',
                country: selected.country ?? '',
            })
            onclose()
            setPostcode('')
        }
    }

    return (
        <AutoComplete
            value={postcode}
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            onChange={handlePostcodeLookup}
            onSelect={handleAddressSelect}
            options={addresses.map((addr) => ({
                value: addr.id,
                label: `${addr.line_1}, ${addr.line_2}, ${addr.post_town}, ${addr.postcode}`,
            }))}
            style={{ width: '100%' }}
            notFoundContent={
                loading ? <Spin size="small" /> : 'No addresses found'
            }
        >
            <Input
                size="large"
                placeholder="Enter postcode"
                suffix={<SearchOutlined />}
            />
        </AutoComplete>
    )
}

export default PostcodeLookup
